export const fillDummyItems = (list, columns) => {
  const remainder = list.length % columns;
  if (remainder === 0) return list;

  const dummyCount = columns - remainder;
  return [
    ...list,
    ...Array.from({ length: dummyCount }, () => ({ isDummy: true })),
  ];
};
